import API from './jsonapi-constants'

export const CONSTANTS = {
  TYPE: {
    LIST: 'LinkTiles',
    ITEM: 'LinkTile',
  },
  ATTRIBUTE: {
    ICON: 'icon',
    LINK_TEXT: 'linkText',
    LINK: 'link',
  },
}

export const PATHS = {
  ICON: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.ICON],
  LINK_TEXT: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.LINK_TEXT],
  LINK: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.LINK],
}

export default {
  ...CONSTANTS,
  PATHS,
}
